<template>
 <div>
    <relationship-update
      :ams_type="ams_type"
      :response_data="response_data"
      :response_included="response_included"
      @updateRelationship="resetRelationship"
      @descriptionUpdate="setDescription"
    ></relationship-update>
   <br>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card bg-variant="light">
          <div id="header-id-product-listing-id">
            <div v-if="showListingSelection">
              <product-listing-select  @selectedItems="setListingId" select_table_heading="Select Product Listing"/>
            </div>
          </div>
          <div id="header-id-storage-space-id" >
            <div v-if="showStorageSpaceSelection">
              <storage-space-select @selectedItems="setStorageSpaceId" select_table_heading="Select Storage Space"/>
            </div>
          </div>
          <b-form-group
            label="Stage"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio-group
              id="btn-radios-2"
              v-model="selected"
              :options="options"
              :aria-describedby="ariaDescribedby"
              button-variant="outline-primary"
              size="sm"
              name="radio-btn-outline"
              buttons
            ></b-form-radio-group>
          </b-form-group>
          <b-form-group 
            label-cols-lg="3"
            label="Product Item"
            label-size="lg"
            label-class="font-weight-bold pt-0"
            class="mb-0"
          >

            <b-form-group
              label="Description:"
              label-for="nested-description"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input id="nested-description"
                v-model="attr_copy.description"
              ></b-form-input>
            </b-form-group>

          <b-form-group
              label="Serial / Copy #:"
              label-for="nested-serial-number"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input id="nested-serial-number" type="number"
                v-model="attr_copy['serial-number']"
              ></b-form-input>
            </b-form-group>

          <b-form-group
              label="Purchased Price :"
              label-for="nested-purchased-price"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_estimate'"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency
                  id="nested-purchased-price"
                  v-model="attr_copy['purchased-price-cents']"
                >
                </b-form-input-currency>
              </b-input-group>
            </b-form-group>
          
          <b-form-group
              label="Estimated Min Price :"
              label-for="nested-estimated-min-price"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_estimate'"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency
                  id="nested-estimated-min-price"
                  v-model="attr_copy['estimated-min-price-cents']"
                ></b-form-input-currency>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Estimated Max Price :"
              label-for="nested-estimated-max-price"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_estimate'"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency
                  id="nested-estimated-max-price"
                  v-model="attr_copy['estimated-max-price-cents']"
                ></b-form-input-currency>
              </b-input-group>
            </b-form-group>

          <b-form-group
              label="Authenticated Min Price :"
              label-for="nested-authenticated-min-price"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_authorize'"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency
                  id="nested-authenticated-min-price"
                  v-model="attr_copy['authenticated-min-price-cents']"
                ></b-form-input-currency>
              </b-input-group>
            </b-form-group>

          <b-form-group
              label="Authenticated Max Price :"
              label-for="nested-authenticated-max-price"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_authorize'"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency
                  id="nested-authenticated-max-price"
                  v-model="attr_copy['authenticated-max-price-cents']"
                ></b-form-input-currency>
              </b-input-group>
            </b-form-group>

          <b-form-group
              label="Asking Price :"
              label-for="nested-asking-price"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency
                  id="nested-asking-price"
                  v-model="attr_copy['asking-price-cents']"
                ></b-form-input-currency>
              </b-input-group>
            </b-form-group>

          <b-form-group
              label="Estimated Quality :"
              label-for="nested-estimated-quality"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_estimate'"
            >
              <!-- <b-input-group size="sm" prepend="%" :append="`${attr_copy['estimated-quality']/100}`">
                <b-form-input
                  id="nested-estimated-quality"
                  v-model="attr_copy['estimated-quality']"
                  type="range" min="0" max="10000"
                ></b-form-input>
              </b-input-group> -->
              <five-star-rating-update v-model="attr_copy['estimated-quality']">
              </five-star-rating-update>
          </b-form-group>

          <b-form-group
              label="Authenticated Quality :"
              label-for="nested-authenticated-quality"
              label-cols-sm="3"
              label-align-sm="right"
              v-show="selected === 'display_authorize'"
            >
              <b-input-group size="sm" prepend="%" :append="`${attr_copy['authenticated-quality']/100}`">
                <b-form-input
                  id="nested-authenticated-quality"
                  v-model="attr_copy['authenticated-quality']"
                  type="range" min="0" max="10000"
                ></b-form-input>
              </b-input-group>
          </b-form-group>
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="1">
        <data-operations
          :modified="modified"
          :can_update="canUpdate"
          :can_delete="canDelete"
          :can_help="canHelp"
          @update="doUpdate"
          @undo="doUndo"
          @delete="doDelete"
          @cancel="doCancel"
          @help="doHelp"
        ></data-operations>
      </b-col>
    </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import {amsMofifiedAttrs} from '@/utils'
import {deepEqual} from '@/utils'
import DataOperations from './DataOperations.vue'
import BFormInputCurrency from './BFormInputCurrency.vue'
import FiveStarRatingUpdate from './FiveStarRatingUpdate.vue'
import RelationshipUpdate from './RelationshipUpdate.vue'
import ProductListingSelect from './ProductListingSelect.vue'
import StorageSpaceSelect from './StorageSpaceSelect.vue'

export default {
  components: {
    BFormInputCurrency,
    DataOperations,
    FiveStarRatingUpdate,
    RelationshipUpdate,
    ProductListingSelect,
    StorageSpaceSelect
  },
  props: {
    id: {
      Type: String
    }
  },
  data () {
    return {
     ams_type: 'product-items',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      response_data: undefined,
      response_included: undefined,
      selected: 'display_estimate',
      options: [
        { text: 'Estimate', value: 'display_estimate' },
        { text: 'Authorize', value: 'display_authorize' /*, disabled: true */ }
      ]
    }
  },
  computed: {
    showListingSelection() {
      return !(this.attr_copy['product-listing-id']?.length)
    },
    showStorageSpaceSelection() {
      return !(this.attr_copy['storage-space-id']?.length > 0 || this.attr_copy['storage-space-id'] > 0)
    },
    canUpdate() {
      return (
        this.attr_copy['product-listing-id']?.length > 0
        && (this.attr_copy['storage-space-id']?.length > 0 || this.attr_copy['storage-space-id'] > 0)
        && (this.attr_copy['serial-number']?.length > 0 || this.attr_copy['serial-number'] > 0)
      )
    },
    canDelete() {
      return true
    },
    canHelp() {
      return true
    }
  },
  methods: {
    jumpToId(id) {
      const element = document.getElementById(id)
      if(element) {
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
      } else {
        window.console.log( "could not find document element by id: " + id)
      }
    },
    resetRelationship(item) {
      window.console.log('resetRelationship for ' + item)
      this.attr_copy[item] = null
      this.jumpToId("header-id-" + item)
    },
    setDescription(description) {
      this.description = description
    },
    display(selected) {
      return selected === this.selected
    },
    setListingId(items) {
      this.attr_copy['product-listing-id'] = items[0].id
    },
    setStorageSpaceId(items) {
      this.attr_copy['storage-space-id'] = items[0].id
    },
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
      http_v1.delete (
        this.apiResourcePath()
      ).then(response => {
        if( response.status == 204) {
          this.$router.go(-1)
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_') + '/' + this.id
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.patch (
         this.apiResourcePath(), {
          ...attr_params
        }
      ).then(() => {
        this.$router.go(-1)
      }).catch(error => {
        window.console.log(error)
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.attr_copy = Object.assign( {}, response.data.data.attributes)
        this.attr_orig = Object.assign( {}, response.data.data.attributes)
        this.response_data = response.data.data
        this.response_included = response.data.included
        this.$emit('gotAttrs', this.attr_copy, this.response_data.attributes['serial-number'])
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>